export const SET_DISCOUNT_CONFIGURATION = 'EMISSOR/SET_DISCOUNT_CONFIGURATION';
